import { render, staticRenderFns } from "./PriceEdit.vue?vue&type=template&id=5122f297&scoped=true"
import script from "./PriceEdit.vue?vue&type=script&lang=js"
export * from "./PriceEdit.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PriceEdit.vue?vue&type=style&index=1&id=5122f297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5122f297",
  null
  
)

export default component.exports